module.exports = __webpack_public_path__ + "static/media/RP_Englishvillage.d2bb3233.jpg";